import { createFeatureSelector } from '@ngrx/store';

export const addressProviderState = createFeatureSelector<OLO.State, OLO.State.AddressProvider>('addressProvider');
